/**
 *
 * @copyright Copyright (c) 2020 Vincent Petry <vincent@nextcloud.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 */

import { PARTICIPANT } from '../constants'

/**
 * A mixin to check retrieve the current participant object
 */
export default {

	computed: {
		participant() {
			const token = this.$store.getters.getToken()
			if (typeof token === 'undefined') {
				return {
					inCall: PARTICIPANT.CALL_FLAG.DISCONNECTED,
				}
			}

			return this.$store.getters.findParticipant(token, this.$store.getters.getParticipantIdentifier()) || {
				inCall: PARTICIPANT.CALL_FLAG.DISCONNECTED,
			}
		},
	},
}
